import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Subscription, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';

import { ActivatedRoute, Router, NavigationEnd, RouteReuseStrategy } from '@angular/router';
import { HttpClient } from '@angular/common/http';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faChartLine, faProjectDiagram, faInfo, faQuestionCircle, faClipboardList, faImage, faDollarSign, faArrowUp, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';

import { ThemeService } from "../theme/theme.service";
import { UserService } from '../services/user.service';
import { NavigationService } from '../services/navigation.service';
import { GlobalSearchService } from '../services/globalsearch.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { HelpPdfComponent } from '../help-pdf/help-pdf.component';
import { FeedbackComponent } from '../feedback/feedback.component';
import { getBaseUrl, isDevEnv } from '../services/util.service';

let excludePaths = ['changelog', 'powerbi', 'getpowerbi'];

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit, OnDestroy {


  user: any;
  opened: boolean = (this.getCookieMenu() == "closed" ? false : true);
  selectedMenuItem: string;
  menuItems: any;  

  themeSub$: Subscription;
  themes: any;
  themeMode = "light";

  sMenuHelpLink = "";
  helpLink = "";
  supportLink = "";
  envTitle = "";
  envLabel = "";
  isLoading: boolean = false;
  showNoData: boolean = false;
  searchValue = null;
  searchFilter = {
    filterBy: '',
    pageIndex: 1,
    pageSize: 1000
  };
  private searchData$: Subscription;
  searchData: any[] = [];
  private searchDebounce$ = new Subject<string>();
  needGroup: boolean = false;
  count: number = 0;
  loadingMenu: boolean = true;
  hasPermission: boolean = true;
  showLegendInOverlay: boolean = true;
  isOverlayOpen: boolean = false;
  renderOverlay: boolean = true;
  legendConfigs = [
    {
      categories: [
        {
          name: 'Existing Business',
          short: 'EB',
          bgColor: '#97BE35',
          bgColor1: '#97BE35',
          hasTooltip: false
        },
        {
          name: 'Potential Growth',
          short: 'PG',
          bgColor: '#F7CF2B',
          bgColor1: '#F7CF2B',
          hasTooltip: false
        },
        {
          name: 'Not Engaged',
          short: 'NE',
          bgColor: '#FF0000',
          bgColor1: '#FF0000',
          hasTooltip: false
        },
        {
          name: 'Unknown Status',
          short: 'US',
          bgColor: '#A3A3A3',
          bgColor1: '#A3A3A3',
          hasTooltip: false
        }
      ],
      badges: [
        {
          name: 'Funded',
          icon: 'dollar-sign',
          content: '',
          transform: '',
          bgColor: '',
          className: 'side-top-left-badge'
        },
        {
          name: 'Years Lost',
          icon: '',
          content: '2',
          transform: '',
          bgColor: '',
          className: 'side-top-bottom-badge'
        },
        {
          name: 'Tenure Of Service',
          icon: '',
          content: '2',
          transform: '',
          bgColor: '',
          className: 'side-top-right-badge'
        }
      ]
    },
    {
      categories: [
        {
          name: 'Healthy',
          short: 'H',
          bgColor: '#97BE35',
          bgColor1: '#27C88F',
          hasTooltip: false
        },
        {
          name: 'Borderline',
          short: 'B',
          bgColor: '#F7CF2B',
          bgColor1: '#F7CF2B',
          hasTooltip: false
        },
        {
          name: 'Critical',
          short: 'C',
          bgColor: '#FF0000',
          bgColor1: '#FF0000',
          hasTooltip: false
        },
        {
          name: 'Unknown Status',
          short: 'US',
          bgColor: '#A3A3A3',
          bgColor1: '#A3A3A3',
          hasTooltip: false
        }
      ],
      badges: [
        {
          name: 'Will Improve',
          icon: 'arrow-up',
          content: '',
          transform: 'rotate-45',
          bgColor: '#27C88F',
          className: 'side-top-right-badge-health'
        },
        {
          name: 'Will Maintain',
          icon: 'arrow-up',
          content: '',
          transform: 'rotate-90',
          bgColor: '#27C88F',
          className: 'side-top-right-badge-health'
        },
        {
          name: 'Will Degrade',
          icon: 'arrow-up',
          content: '',
          transform: 'rotate-90',
          bgColor: '#F7CF2B',
          className: 'side-top-right-badge-health'
        },
        {
          name: 'Degrading Now',
          icon: 'arrow-up',
          content: '',
          transform: 'rotate-135',
          bgColor: '#FF0000',
          className: 'side-top-right-badge-health'
        }
      ]
    }
  ];

  constructor(public activatedRoute: ActivatedRoute,
    public router: Router,
    public userService: UserService,  
    private themeService: ThemeService,
    public navService: NavigationService,
    library: FaIconLibrary,
    public dialog: MatDialog,
    private globalSearchService: GlobalSearchService,
  ) {
    library.addIcons(faChartLine,faFileExcel,faProjectDiagram,faInfo,faQuestionCircle,faClipboardList, faImage, faDollarSign, faArrowUp, faQuestion);
   }

  ngOnInit(): void {

    console.log("View INIT")
    console.log(JSON.stringify(this.router.url));
    switch (getBaseUrl().split("//")[1].split(".")[0]) {
    case "estate-maps-dev": {
      this.envTitle = "(DEV)"
      this.envLabel = "DEV"
      break;
    }
    case "estate-maps-qa": {
      this.envTitle = "(QA)"
      this.envLabel = "QA"
      break;
    }
    case "estatemaps": {
      this.envTitle = ""
      this.envLabel = ""
      break;
    }
    default:{
      this.envTitle = "(DEV)"
      this.envLabel = "DEV"
      break;
    }  
  }
    // Get the selected menu from the route - strip the first "/" and anything after the second "/"
    const routemenu = this.getRoutePath();

    // console.log(routemenu);

    // Subscribe to the user and get it
    this.userService.user$.subscribe(data => {      
      
      // console.log("user > " + JSON.stringify(data))
      
      if (data != null) {
        this.user = data[0];
        if (this.user.initials == "" || this.user.initials == null) {
          if (this.user.fullname != "" && this.user.fullname != null) {
            if(this.user.fullname.lastIndexOf(",")>-1){
              let finit = "?"
              if(this.user.fullname.lastIndexOf(",")>-1) finit = this.user.fullname.substr(this.user.fullname.lastIndexOf(",") + 2, 1);
              this.user["initials"] = finit + this.user.fullname.substr(0, 1);
            } else {
              let finit = "?"
              if(this.user.fullname.lastIndexOf(" ")>-1) finit = this.user.fullname.substr(this.user.fullname.lastIndexOf(" ") + 1, 1);
              this.user["initials"] = this.user.fullname.substr(0, 1) + finit;
            }
          } else {
            this.user.initials = "??";
          }
        }
        if (this.user) {
          this.navService.useNewLayout$.next(this.user.layout === 'new');
        }
        this.navService.loadMenus()
      } else {
        this.user = {id:"",username:"",initials:""}
      }
    })
    this.userService.loadUser();

    // Subscribe to the menus
    this.navService.menu$.subscribe(data => {
      this.menuItems = data;
      this.selectedMenuItem = routemenu;
      this.navService.setMenuSelectedItem(routemenu)

      // get the help and support link
      this.menuItems.forEach(x => {
        if (x["name"] == "home") {
          this.helpLink = (x["help-service"] ? x["help-service"] : "");
          this.supportLink = (x["support-service"] ? x["support-service"] : "");

        }

      });

      this.checkPermission(routemenu);
      this.checkHeight();
    })
  
    this.navService.menuSelectedItem$.subscribe(x => {
      if (x != null) {
        this.selectedMenuItem = x;

        // get the menu help service link if it exists
        this.sMenuHelpLink = "";
        this.menuItems.forEach(x => {
          if (x["name"] == this.selectedMenuItem) {
            this.sMenuHelpLink = (x["help-service"] ? x["help-service"] : "");
          }
        });
      }


    });

    // Subscribe to themes and get them
    this.themeService.themes$.subscribe(data => {
      this.themes = data;
    })
    this.themeService.getThemes();

    this.themeSub$ = this.themeService.getSelectedTheme().subscribe(x => {
      //console.log("set theme"+ JSON.stringify(x))
      if (x["value"] == "dxc-light-theme") {
        this.themeMode = "light";
      }
      if (x["value"] == "dxc-dark-theme") {
        this.themeMode = "dark";
      }
    });

    this.searchData$ = this.globalSearchService.searchResult$.subscribe((res: any) => {
      if (res) {
        const { loading, data, count } = res;
        if (count === this.count) {
          if (loading){
            this.isLoading = true;
            this.showNoData = false;
          } else {
            const accounts = JSON.parse(data[0]['accounts'] || '[]') || [];
            const faqs = JSON.parse(data[0]['faqs'] || '[]') || [];
            accounts.forEach(item => {
              item.redirectName = 'landscape';
              item.queryParam = 'a';
              item.itemId = `${item.clientclass}${item.id}`;
            });
            faqs.forEach(item => {
              item.clientclass = 'FAQ';
              item.redirectName = 'faq';
              item.name = item.question;
              item.queryParam = '';
              item.itemId = `${item.clientclass}${item.id}`;
            });
            this.searchData = JSON.parse(JSON.stringify(accounts.concat(faqs)));
            if (this.searchData.length === 0) {
              this.showNoData = true;
            }
            this.needGroup = true;
            this.isLoading = false;
          }
        }
      }
    });

    this.searchDebounce$.pipe(debounceTime(1000), distinctUntilChanged()).subscribe((value) => {
      this.searchAccounts(value);
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const path = this.getRoutePath();
        this.navService.setMenuSelectedItem(path);
      }
    });

    window.onresize = () => {
      this.checkHeight();
    };
  }

  ngOnDestroy() {
    console.log("---- View destroy")
    this.userService.user$.unsubscribe();
    this.navService.menu$.unsubscribe();
    this.themeSub$.unsubscribe();
    this.searchData$.unsubscribe();
    this.searchDebounce$.unsubscribe();
  }

  getRoutePath() {
    let r = this.router.url;
    const i1 = r.indexOf("/");
    if (i1 >= 0) r = r.substr(i1 + 1);
    const i2 = r.indexOf("/");
    if (i2 >= 0) r = r.substring(0, i2);
    return r.split('#')[0].split('?')[0];
  };

  go(name: string) {

    // check if there is a redirect
    let redirect = "";
    this.menuItems.forEach(x => {
      if (name == x["name"]) {
        if (x["redirect-url"]) {
          redirect = x["redirect-url"].trim();
        }
      }
    });

    if (redirect != "") {
      window.open(redirect);
    } else {
      this.router.navigate(["/", name]);
      this.navService.setMenuSelectedItem(name);
      this.hasPermission = true;
      this.resetLandscapeConfig();
    }

  }

  toggleMenu() {
    this.opened = !this.opened;

    this.checkHeight();
    this.renderOverlay = false;
    setTimeout(() => {
      this.renderOverlay = true;
    }, 10);
  }

  open() {
    this.navService.setShowMenu(true);
    // save in a cookie
    this.setCookieMenu("opened");
  }

  close() {
    this.navService.setShowMenu(false);
    this.setCookieMenu("closed");
  }


  changeThemeMode(mode) {
    if (mode == "light") {
      this.themeService.setSelectedThemeByName("dxc-light-theme");
      this.themeMode = "light";
    }
    if (mode == "dark") {
      this.themeService.setSelectedThemeByName("dxc-dark-theme");
      this.themeMode = "dark";
    }
  }

  themeChangeHandler(themeToSet) {
    this.themeService.setSelectedTheme(themeToSet);
  }


  showHelpDialog() {
    // oepn the help dialog
    let data = {
      helpPage:this.navService.sLandscapePage
    }

    let dialogRef = this.dialog.open(HelpPdfComponent, {
      height: '700px',
      width: '1010px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      // all the same to me
    })  
  }

  showHelp() {
    var win = window.open(this.helpLink, '_blank');
    win.focus();
  }

  showSupport() {
    var win = window.open(this.supportLink, '_blank');
    win.focus();
  }

  getCookieMenu() {
    let name = "lndscp-menu"
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return "";

  }

  setCookieMenu(value) {
    let d: Date = new Date();
    let expireDays = 365;
    let name = "lndscp-menu"
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    let expires: string = `expires=${d.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/;SameSite=Strict`;
  }

  disableSearchDropdown() {
    return !this.isLoading && !this.showNoData && this.searchData.length === 0;
  }

  groupByFn = item => item.clientclass || 'Rest of Business';

  searchFn = (value: string, item: any) => {
    return true;
  }

  handleSearch(event) {
    const { term } = event;
    if (term.length !== 1) {
      this.searchDebounce$.next(term);
    }
  }

  handleBlur() {
    this.searchDebounce$.next('');
    this.isLoading = false;
    this.showNoData = false;
    this.searchData = [];
  }

  searchAccounts(value) {
    if (value) {
      if (value.toLowerCase() === 'faq') {
        const item = this.menuItems.find(menu => menu.name === 'faq');
        this.needGroup = false;
        this.isLoading = false;
        if (item) {
          this.showNoData = false;
          this.searchData = [{
            itemId: 'FAQ',
            name: 'FAQ',
            redirectName: 'faq',
            id: null
          }];
        } else {
          this.searchData = [];
          this.showNoData = true;
        }
      } else {
        this.count++;
        this.globalSearchService.searchData(value, this.count);
      }
    } else {
      this.handleBlur();
    }
  }

  selectAccount(event) {
    if(event === undefined) return;
    const { id, redirectName, queryParam } = event;
    const params = {};
    if (queryParam) {
      params[queryParam] = id;
    }

    if (redirectName === 'faq') {
      this.globalSearchService.setFaqId(id);
      this.router.navigate([redirectName]);
    } else {
      this.router.navigate([redirectName], {
        relativeTo: this.activatedRoute,
        queryParams: params,
        queryParamsHandling: 'merge',
        skipLocationChange: false,
        replaceUrl: false
      });
    }
    if (redirectName !== this.selectedMenuItem && this.selectedMenuItem === 'landscape') {
      this.resetLandscapeConfig();
    }
    this.navService.setMenuSelectedItem(redirectName);
    this.hasPermission = true;

    setTimeout(() => {
      document.getElementById('globalSearchInput').blur();
      this.searchValue = null;
      this.handleBlur();
    }, 100);
  }

  showFeedBackDialog() {
    // oepn the help dialog
    let data = {
      category:'',
      comments:'',
      imgURL:'',
      score:''
    }

    let dialogRef = this.dialog.open(FeedbackComponent, {
      id:'sendFeebbackDl',
      height: '560px',
      width: '560px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      // all the same to me
    })  
  }

  checkPermission(path: string) {
    if(!isDevEnv()){
      excludePaths = ['changelog', 'powerbi'];
    }
    if (this.navService.menuLoaded) {
      if (excludePaths.includes(path)) {
        this.hasPermission = true;
      } else {
        const item = this.menuItems.find(menu => menu.name === path);
        this.hasPermission = item ? true : false;
      }  
      this.loadingMenu = false;
    }
  }

  resetLandscapeConfig() {
    const { useNewLayout } = this.navService.landscapePageConfig;
    this.navService.setLandscapeConfig(false, 1, useNewLayout, useNewLayout ? 1 : 3, null);
  }

  openOverlay() {
    this.isOverlayOpen = true;
  }
  hideOverlay() {
    this.isOverlayOpen = false;
  }

  checkHeight() {
    const headerFooterHeight = 84;
    const ele = document.getElementsByClassName('mat-nav-list');
    const menuListHeight = ele && ele[0] ? ele[0].clientHeight : 200;
    const diff = window.innerHeight - headerFooterHeight - menuListHeight;
    this.showLegendInOverlay = diff < (this.opened ? 315 : 290);
  }

  toggleLayout() {
    this.navService.toggleLayout();
  }
}
